import { Box, styled, TextField } from "@mui/material";

interface RootContainerProps {
    showBorderBottom?: boolean;
}

export const RootContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== "showBorderBottom",
})<RootContainerProps>(({ theme, showBorderBottom }) => ({
    position: "relative",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: theme.spacing(3, 0),
    ...(showBorderBottom && { borderBottom: `1px solid ${theme.palette.core.grey._30}` }),
}));

export const TopContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    padding: theme.spacing(0, 2, 2),
}));

export const ArticleImage = styled("img")(({ theme }) => ({
    width: 60,
    height: 60,
    objectFit: "contain",
    marginRight: theme.spacing(3),
}));

export const ArticleInfoContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: 2,
}));

export const BottomContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flex: 1,
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
}));

export const RightContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));

export const StyledSelect = styled(TextField)({
    height: 32,

    "& .MuiInputBase-root": {
        height: 32,
    },
});
